import { ListBulletIcon } from "@heroicons/react/24/outline";
import {
  SectionEmptyState,
  SectionHeader,
  SectionPanel,
} from "../../../../componentLibrary/SectionPanel";

interface Props {
  topicTitle: string;
}

export default function PlansSection({ topicTitle }: Props) {
  return (
    <SectionPanel>
      <SectionHeader
        icon={<ListBulletIcon className="w-5 h-5 text-electrum-300 shrink-0" />}
        title="My Plans"
      />
      <SectionEmptyState>
        <p className="text-sm text-gray-400 py-2">
          More {topicTitle} strategies are coming soon.
        </p>
      </SectionEmptyState>
    </SectionPanel>
  );
}
